export default __webpack_public_path__ + "assets/images/laravel.3f96be9.png";